export enum StoreName {
    ANOMALIE_PILOTAGE = 'anomaliePilotage',
    PROJETS = 'projets',
    PROJETS_AUDIT = 'projetsAudit',
    REQUESTS = 'requests',
    SYNC_ERRORS = 'syncErrors',
    TAXONOMIE = 'taxonomie',
    PHOTOS = 'photos',
}
